import type { SubscriptionProvider } from '../../firebaseApp';

export const customerPortalUrl = 'https://billing.stripe.com/p/login/6oU8wOgPH2EG7BOf7gaAw00';
export const amplioPlus_checkoutUrl = 'https://buy.stripe.com/8x214m1UNbbc4pC6AKaAw0b';

// Google Play and Apple do not offer per-subscription deep links from the web,
// so these link to each store's general subscription-management surface.
export const googlePlaySubscriptionsUrl = 'https://play.google.com/store/account/subscriptions';
export const appleSubscriptionsUrl = 'https://apps.apple.com/account/subscriptions';

export function getCheckoutUrl(email: string): string {
  return amplioPlus_checkoutUrl + '?locked_prefilled_email=' + encodeURIComponent(email);
}

export function getCustomerPortalUrl(email: string): string {
  return customerPortalUrl + '?prefilled_email=' + encodeURIComponent(email);
}

/**
 * Resolves the subscription-management URL for the provider that granted the
 * user's Plus entitlement. Falls back to the Stripe customer portal when the
 * provider is missing or unrecognized.
 */
export function getManageSubscriptionUrl(
  provider: SubscriptionProvider | undefined,
  email: string,
): string {
  switch (provider) {
  case 'google_play':
    return googlePlaySubscriptionsUrl;
  case 'apple_app_store':
    return appleSubscriptionsUrl;
  case 'stripe':
  default:
    return getCustomerPortalUrl(email);
  }
}

/**
 * Human-readable name of the store a user subscribed through, or `null` when
 * they're billed directly (Stripe) or the provider is unknown — in which case
 * we don't call out anything special.
 */
export function getSubscriptionProviderLabel(
  provider: SubscriptionProvider | undefined,
): string | null {
  switch (provider) {
  case 'google_play':
    return 'Google Play';
  case 'apple_app_store':
    return 'the Apple App Store';
  default:
    return null;
  }
}
